import React from 'react';

const NavigationBack = () => (
    <React.Fragment>
        <path
              d="M14.2.033a.287.287,0,0,0-.3.018L6.071,5.456V.286a.286.286,0,0,0-.571,0V11.714a.286.286,0,1,0,.571,0V6.544l7.838,5.405a.287.287,0,0,0,.3.018.286.286,0,0,0,.153-.253V.286A.286.286,0,0,0,14.2.033ZM13.786,11.17,6.289,6l7.5-5.17Z"
              transform="translate(-5 0.509)"/>
    </React.Fragment>
)

export default NavigationBack
